import {
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

const styles = (theme) => ({
  root: {
    padding: theme.spacing.unit * 3,
    maxWidth: 800,
  },
  section: {
    marginBottom: theme.spacing.unit * 3,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  envLabel: {
    fontWeight: 600,
    marginRight: theme.spacing.unit,
  },
  envValue: {
    fontFamily: 'monospace',
    fontSize: 14,
  },
  envRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing.unit,
  },
  table: {
    marginTop: theme.spacing.unit,
  },
  helpText: {
    color: '#666',
    fontSize: 12,
    marginTop: 4,
  },
  errorMsg: {
    color: 'red',
    padding: theme.spacing.unit * 2,
  },
  versionInfo: {
    marginBottom: theme.spacing.unit * 2,
    color: '#555',
  },
});

const HelpLanding = ({ classes }) => {
  const [dbInfo, setDbInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDbInfo = async () => {
      try {
        const result = await window.sch.get('/api/utils/db_info');
        setDbInfo(result);
        setError(null);
      } catch (err) {
        setError(err.message || 'Failed to fetch database info');
        setDbInfo(null);
      } finally {
        setLoading(false);
      }
    };

    fetchDbInfo();
  }, []);

  const formatValue = (val) => {
    if (val === null || val === undefined) return 'unavailable';
    return val.toLocaleString();
  };

  return (
    <div className={classes.root}>
      <Typography variant="h5" gutterBottom>
        System Information
      </Typography>

      <Typography className={classes.versionInfo}>
        UI Version: {process.env.REACT_APP_VER || 'unknown'}
      </Typography>

      {loading && <CircularProgress size={24} />}

      {error && (
        <Typography className={classes.errorMsg}>Error: {error}</Typography>
      )}

      {dbInfo && (
        <>
          <Paper className={classes.paper}>
            <Typography variant="h6" gutterBottom>
              Database Environment
            </Typography>
            <Typography variant="body2" color="textSecondary" gutterBottom>
              Identifies which HDMS database the API is connected to. Different
              hosts indicate different environments (e.g. Production, Staging,
              Beta).
            </Typography>
            <div className={classes.envRow}>
              <span className={classes.envLabel}>Host:</span>
              <span className={classes.envValue}>
                {formatValue(dbInfo.env?.HDMS_HOST_NAME)}
              </span>
            </div>
            <div className={classes.envRow}>
              <span className={classes.envLabel}>Database:</span>
              <span className={classes.envValue}>
                {formatValue(dbInfo.env?.HDMS_DB_NAME)}
              </span>
            </div>
          </Paper>

          <Paper className={classes.paper}>
            <Typography variant="h6" gutterBottom>
              Data High-Water Marks
            </Typography>
            <Typography variant="body2" color="textSecondary" gutterBottom>
              These values indicate how current the data is. Higher numbers mean
              more recent data. Compare against known production values to gauge
              freshness.
            </Typography>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell>Metric</TableCell>
                  <TableCell align="right">Value</TableCell>
                  <TableCell>Source</TableCell>
                  <TableCell>Description</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>Max Account</TableCell>
                  <TableCell align="right">
                    {formatValue(dbInfo.max_account)}
                  </TableCell>
                  <TableCell>HDMS tbl_account_member</TableCell>
                  <TableCell>Highest patient account number</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Max Work Order</TableCell>
                  <TableCell align="right">
                    {formatValue(dbInfo.max_work_order)}
                  </TableCell>
                  <TableCell>HDMS tbl_ps_workorder</TableCell>
                  <TableCell>Highest work order ID</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Max V ID</TableCell>
                  <TableCell align="right">
                    {formatValue(dbInfo.max_v_id)}
                  </TableCell>
                  <TableCell>MongoDB v collection</TableCell>
                  <TableCell>Highest docflow document ID</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Paper>
        </>
      )}
    </div>
  );
};

const mapStateToProps = (stateFromStore) => ({
  me: stateFromStore.me,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(HelpLanding))
);
